import { render, staticRenderFns } from "./PaymentGateway.vue?vue&type=template&id=627e2dbe&scoped=true&"
import script from "./PaymentGateway.vue?vue&type=script&lang=js&"
export * from "./PaymentGateway.vue?vue&type=script&lang=js&"
import style0 from "./PaymentGateway.vue?vue&type=style&index=0&id=627e2dbe&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "627e2dbe",
  null
  
)

component.options.__file = "PaymentGateway.vue"
export default component.exports